import { defineComponent as O, getCurrentInstance as C, reactive as S, ref as T, onMounted as w } from "vue";
import { mediaQueryObserver as p, resizeObserver as m } from "@sunrise/shared";
import D from "./index173.js";
import { track as _ } from "@sunrise/tracking";
import { ScreenSize as h } from "@sunrise/types";
const N = O({
  name: "MsCroppedCopy",
  components: {
    MsInteractiveIcons: D
  },
  props: {
    tealiumData: {
      default: null,
      type: Object
    },
    labelTextOpen: {
      default: "mehr",
      type: String
    },
    labelTextClose: {
      default: "weniger",
      type: String
    },
    linesToShow: {
      default: 5,
      type: Number
    },
    isDisabled: {
      default: !1,
      type: Boolean
    },
    initialHeight: {
      type: Number,
      default: 0
    }
  },
  setup(t) {
    var c;
    const i = (c = C()) == null ? void 0 : c.proxy;
    let o, r;
    const e = S({
      isOpen: !1,
      contentHeight: t.initialHeight + "px",
      showButton: !0
    }), l = T(null);
    function s() {
      var n;
      o = ((n = l.value) == null ? void 0 : n.scrollHeight) || 0, e.isOpen && (e.contentHeight = o + "px");
    }
    function u() {
      r = m.observe(l.value, s);
    }
    w(() => {
      var g;
      o = ((g = l.value) == null ? void 0 : g.scrollHeight) || 0;
      const n = t.linesToShow * a();
      o < n ? (e.contentHeight = o + "px", e.showButton = !1) : (e.contentHeight = n + "px", e.showButton = !0), p.getCurrentScreenSizes() < h.M && u(), p.subscribe((y) => {
        y < h.M ? u() : m.unobserve(r), s();
      });
    });
    function b(n) {
      return n * a() + "px";
    }
    function a() {
      return l.value === null ? 0 : parseInt(window.getComputedStyle(l.value).lineHeight, 10);
    }
    function f() {
      return e.isOpen ? t.labelTextClose : t.labelTextOpen;
    }
    function d() {
      const n = {
        ...t.tealiumData,
        mslayer_element_type_text: f()
      };
      _(n);
    }
    function H() {
      t.isDisabled || (e.isOpen = !0, e.contentHeight = o + "px", i == null || i.$emit("open"));
    }
    function x() {
      t.isDisabled || (e.isOpen = !1, e.contentHeight = b(t.linesToShow), i == null || i.$emit("close"));
    }
    function v() {
      t.isDisabled || (d(), e.isOpen ? x() : H());
    }
    return {
      buttonText: f,
      croppedCopyContent: l,
      state: e,
      onToggle: v
    };
  }
});
export {
  N as default
};
